<template>
<div class="all">
  <v-header title="消息中心"></v-header>  
  <el-container id="Msg">  
    <el-aside >
      <v-sidebar v-bind:class="{'sidebar' : isShow,'hideSidebar':isHide}"></v-sidebar>
    </el-aside>
    <el-main class="msgRight">
      <!-- <keep-alive > -->
          <router-view/>
      <!-- </keep-alive> -->
    </el-main>
  </el-container>
</div>
</template>
<script>
/*
   * 导入
   * 头部、
   * footer、
   * 面包屑
   * 模块
   * */
// import vHeader from '@/layout/BackendHeader.vue'
import vHeader from '@/layout/Header1.vue'
import vSidebar from '@/layout/MsgSidebar.vue'
//  import vFooter from "@/components/manage/layout/Footer.vue"
//  import vCrumbnav from "@/layout/Crumbnav.vue"

export default {
//        组件名称
  name: 'MsgHome',
  //        导入相关模块
  components: {vHeader,vSidebar},
  //        初始化变量
  data () {
    /// /            返回值
    return {
      //                初始化高度，后期可变
      fullHeight: {height: ''},
      //                默认显示
      isShow: true,
      //                默认隐藏
      isHide: false }
  },
  //        页面加载完渲染
  created () {
    /// /            this.changTab()
    /// /            获取高度
    // this.height()
    //    },
    /// /        一直在执行
    //    updated(){ this.height()
  },
  methods: {
    //            判断跳转路径
    

  },
  mounted () {
   
  },
  //        监视屏幕大小改变
  watch: {
    
  }
}
</script>

<style scoped>
.all {
  width: 100%;
  height: 100%;
    /* padding-top:60px; */
  /* height: 614px; */
  box-sizing: border-box;
  padding-top:60px;
}
  /* body{
    margin:0;
  }
  .mains{
    margin-left:17%;
    overflow: auto;
    padding:0 1%
  } */
  #Msg{
    width: 96%;
    margin:0 auto;
    height: calc(100% - 100px);
    margin-top: 20px;
    box-sizing: border-box;
    background: #fff;
    border:1px solid #E5E5E5;
  }
  .el-container{
    height: 100%;
  }
  .el-aside{
    width: 350px;
    overflow: inherit;
  }
  .msgRight{
    /* padding-top: 30px; */
    padding: 0;
    position: relative;
  }
  .el-main.msgRight::-webkit-scrollbar{width: 2px;}
  .el-main.msgRight::-webkit-scrollbar-thumb{background:rgba(193,193,193, .4);}
  /* @media screen and (min-width: 1400px) {
     .mains{
      margin-left:10%;
      overflow: auto;
    }
  } */
  .backend-div{
    background-color:#F5F6FA;
    padding-top: 20px
  }
</style>



// WEBPACK FOOTER //
// src/pages/MsgHome.vue